import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/create'
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { fetchRequest as fetchWorkspaces } from '../../actions/workspaces/list';
import { fetchRequest as fetchUser } from '../../actions/user/getUser';

function* operation(data) {
  try {
    const { json } = data.payload; 
    const response = yield call(axios.post, 
      `${config.API_URL}/workspace`,
      json,
      { headers: getLocalUser() }
      );
    yield put(fetchSuccess(response.data.data));

    // Keep both workspace-list sources in sync: the on-demand
    // workspace_list slice AND the user payload that feeds
    // WorkspaceContext (header switcher, dashboard).
    yield put(fetchWorkspaces());
    yield put(fetchUser());
  } catch (error) {
    console.error(error)
    yield put(Error(error))
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
